import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useIsAppRouter } from '~/context/common/StaticContext';
import {
  useGetIsReturnUser,
  useHomeRouterReason
} from '~/context/home/GlobalContext';
import {
  isSpaNavigation,
  navPerformanceNow
} from '~/utilities/navigationTiming';

const HOME_LOAD_TIME_EVENT = 'home-load-time';

export default function useTrackHomeLoadTime(): void {
  const homeRouterReason = useHomeRouterReason();
  const isAppRouter = useIsAppRouter();
  const isReturningUser = useGetIsReturnUser();
  const trackEvent = useTrackEvent();

  useEffectOnce(() => {
    const attributes = {
      homeRouterReason,
      isReturningUser,
      navMode: isSpaNavigation() ? 'spa' : 'doc',
      router: isAppRouter ? 'app' : 'pages',
      unit: 'ms',
      value: navPerformanceNow()
    };

    trackEvent(HOME_LOAD_TIME_EVENT, attributes);
    datadogRum.addAction(HOME_LOAD_TIME_EVENT, attributes);
  }, [homeRouterReason, isAppRouter, isReturningUser, trackEvent]);
}
